import { render } from "./PublicReceiptPage.vue?vue&type=template&id=10663362&scoped=true"
import script from "./PublicReceiptPage.vue?vue&type=script&lang=js"
export * from "./PublicReceiptPage.vue?vue&type=script&lang=js"

import "./PublicReceiptPage.vue?vue&type=style&index=0&id=10663362&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10663362"]])

export default __exports__